export const supportsWebP = () => {
  try {
    const canvas = document.createElement('canvas');
    canvas.width = 1;
    canvas.height = 1;
    return canvas.toDataURL('image/webp').includes('data:image/webp');
  } catch {
    return false;
  }
};